/**
 * The phonics check with a grown-up.
 *
 * The child says each sound or word shown; the grown-up marks it. A stage is
 * passed with at least four in five of its sounds AND every one of its tricky
 * words. The check stops at the first stage not passed: the stages build on
 * each other, so a later one can never count without the earlier.
 */
export const SOUNDS_TO_PASS = 0.8;
export function scoreStage(stage, marks) {
    const soundsRight = marks.graphemes.filter(Boolean).length;
    const wordsRight = marks.tricky.filter(Boolean).length;
    const soundsTotal = stage.graphemes.length;
    const wordsTotal = stage.trickyWords.length;
    return {
        stage: stage.stage,
        soundsRight,
        soundsTotal,
        wordsRight,
        wordsTotal,
        passed: marks.graphemes.length === soundsTotal &&
            marks.tricky.length === wordsTotal &&
            soundsRight >= Math.ceil(soundsTotal * SOUNDS_TO_PASS) &&
            wordsRight === wordsTotal,
    };
}
/**
 * The highest stage passed without a gap from stage 1, or 0 if stage 1 was
 * not passed. Marks are given in stage order; anything after the first stage
 * not passed is ignored.
 */
export function placedStage(stages, marks) {
    let placed = 0;
    for (let i = 0; i < stages.length && i < marks.length; i += 1) {
        if (!scoreStage(stages[i], marks[i]).passed)
            break;
        placed = stages[i].stage;
    }
    return placed;
}
//# sourceMappingURL=phonics-check.js.map